module.exports = __webpack_public_path__ + "static/img/capture-system.4f92616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/capture-system.png
// module id = m0CR
// module chunks = 0